import { render, staticRenderFns } from "./ProductsListViewEM.vue?vue&type=template&id=73519297&scoped=true"
import script from "./ProductsListViewEM.vue?vue&type=script&lang=js"
export * from "./ProductsListViewEM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73519297",
  null
  
)

export default component.exports